<template>
  <el-cascader v-model="tempData" class="region-cascade" :options="location" @change="change" ref="myCascader"
               :style="`width: ${width}`" :disabled="disabled" :clearable="clearable" :props="props"/>
</template>

<script>
  import location from "@assets/data/locationLevel3"
  export default {
    name: "RegionCascade",
    model: {
      event: 'change',
    },
    props: {
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: "100%",
      },
      value: String,
    },
    data() {
      return {
        location,
        tempData: this.value,
        props: {
          checkStrictly: true,
          emitPath: false,
        },
      }
    },
    watch: {
      value(val) {
        this.tempData = val;
      }
    },
    methods: {
      change(val) {
        this.props.checkStrictly && this.hideCascader();
        this.$emit('change', val || "");
      },
      hideCascader() {
        this.$refs["myCascader"].toggleDropDownVisible(false);
      }
    }
  }
</script>

<style scoped lang="scss">
  .region-cascade {
    line-height: normal;
  }
</style>
